export default __webpack_public_path__ + "static/media/0x5314ba045a459f63906aa7c76d9f337dcb7d6995.7cd84a3e.webp";